// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"657e28e0","896":"6b8b99f3"}[chunkId] + ".chunk.js";
};